import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import { LinkUserApplicationRequestObjectType } from '../../../services/NwApplicationServices/APIService/types';

import { useNwApplicationService } from '../useNwApplicationService';

interface UseLinkUserApplicationInterface {
  linkUserApplicationApi: UseMutateAsyncFunction<
    void,
    Error,
    LinkUserApplicationRequestObjectType
  >;
  error: string | null;
  status: MutationStatus;
}

const useLinkUserApplicationApi = (): UseLinkUserApplicationInterface => {
  const { nwApplicationService } = useNwApplicationService();

  const linkUserApplication = (
    requestObject: LinkUserApplicationRequestObjectType
  ) => {
    return nwApplicationService.linkUserApplication(requestObject);
  };

  const { mutateAsync, error, status } = useMutation(linkUserApplication, {
    mutationKey: ['linkUserApplicationApi']
  });

  return {
    linkUserApplicationApi: mutateAsync,
    error: error ? getAPIErrorMessage(error) : null,
    status
  };
};

export { useLinkUserApplicationApi };
